// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-slider .v-slider__container input {
  cursor: default;
  padding: 0;
  width: 100%;
  display: none;
}
:where(.vuetify-styles) .v-slider > .v-input__append,
:where(.vuetify-styles) .v-slider > .v-input__prepend {
  padding: 0;
}

:where(.vuetify-styles) .v-slider__container {
  position: relative;
  min-height: inherit;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
:where(.vuetify-styles) .v-input--disabled .v-slider__container {
  opacity: var(--v-disabled-opacity);
}
:where(.vuetify-styles) .v-input--error:not(.v-input--disabled) .v-slider__container {
  color: rgb(var(--v-theme-error));
}

:where(.vuetify-styles) .v-slider.v-input--horizontal {
  align-items: center;
  margin-inline: 8px 8px;
}
:where(.vuetify-styles) .v-slider.v-input--horizontal > .v-input__control {
  min-height: 32px;
  display: flex;
  align-items: center;
}

:where(.vuetify-styles) .v-slider.v-input--vertical {
  justify-content: center;
  margin-top: 12px;
  margin-bottom: 12px;
}
:where(.vuetify-styles) .v-slider.v-input--vertical > .v-input__control {
  min-height: 300px;
}

:where(.vuetify-styles) .v-slider.v-input--disabled {
  pointer-events: none;
}

:where(.vuetify-styles) .v-slider--has-labels > .v-input__control {
  margin-bottom: 4px;
}

:where(.vuetify-styles) .v-slider__label {
  margin-inline-end: 12px;
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VSlider/VSlider.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,UAAU;EACV,WAAW;EACX,aAAa;AACf;AACA;;EAEE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,kCAAkC;AACpC;AACA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB","sourcesContent":[".v-slider .v-slider__container input {\n  cursor: default;\n  padding: 0;\n  width: 100%;\n  display: none;\n}\n.v-slider > .v-input__append,\n.v-slider > .v-input__prepend {\n  padding: 0;\n}\n\n.v-slider__container {\n  position: relative;\n  min-height: inherit;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n}\n.v-input--disabled .v-slider__container {\n  opacity: var(--v-disabled-opacity);\n}\n.v-input--error:not(.v-input--disabled) .v-slider__container {\n  color: rgb(var(--v-theme-error));\n}\n\n.v-slider.v-input--horizontal {\n  align-items: center;\n  margin-inline: 8px 8px;\n}\n.v-slider.v-input--horizontal > .v-input__control {\n  min-height: 32px;\n  display: flex;\n  align-items: center;\n}\n\n.v-slider.v-input--vertical {\n  justify-content: center;\n  margin-top: 12px;\n  margin-bottom: 12px;\n}\n.v-slider.v-input--vertical > .v-input__control {\n  min-height: 300px;\n}\n\n.v-slider.v-input--disabled {\n  pointer-events: none;\n}\n\n.v-slider--has-labels > .v-input__control {\n  margin-bottom: 4px;\n}\n\n.v-slider__label {\n  margin-inline-end: 12px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
